const DOCUMENT = 'BULK_EDIT_CHECKIN_CHECKOUT_';

const actions = {
  LOAD_CLOCKIN_CLOCKOUT_REQUEST: `${DOCUMENT}LOAD_CLOCKIN_CLOCKOUT_REQUEST`,
  LOAD_CLOCKIN_CLOCKOUT_SUCCESS: `${DOCUMENT}LOAD_CLOCKIN_CLOCKOUT_SUCCESS`,
  LOAD_CLOCKIN_CLOCKOUT_CANCEL: `${DOCUMENT}LOAD_CLOCKIN_CLOCKOUT_CANCEL`,
  UPDATE_CLOCKIN_CLOCKOUT_REQUEST: `${DOCUMENT}UPDATE_CLOCKIN_CLOCKOUT_REQUEST`,
  UPDATE_CLOCKIN_CLOCKOUT_SUCCESS: `${DOCUMENT}UPDATE_CLOCKIN_CLOCKOUT_SUCCESS`,
  CHANGE_PROPERTY: `${DOCUMENT}CHANGE_PROPERTY`,
  VALIDATE_PROPERTY: `${DOCUMENT}VALIDATE_PROPERTY`,

  loadClockInClockOutRequest: data => {
    return {
      type: actions.LOAD_CLOCKIN_CLOCKOUT_REQUEST,
      payload: { ...data },
    };
  },

  loadClockInClockOutSuccess: data => ({
    type: actions.LOAD_CLOCKIN_CLOCKOUT_SUCCESS,
    payload: data,
  }),

  loadClockInClockOutCancel: data => ({
    type: actions.LOAD_CLOCKIN_CLOCKOUT_CANCEL,
    payload: data,
  }),

  updateClockInClockOutRequest: data => {
    return {
      type: actions.UPDATE_CLOCKIN_CLOCKOUT_REQUEST,
      payload: { ...data },
    };
  },

  updateClockInClockOutSuccess: data => ({
    type: actions.UPDATE_CLOCKIN_CLOCKOUT_SUCCESS,
    payload: data,
  }),

  changeProperty: data => ({
    type: actions.CHANGE_PROPERTY,
    payload: data,
  }),

  validateProperty: data => ({
    type: actions.VALIDATE_PROPERTY,
    payload: data,
  }),
};

export default actions;
